export default __webpack_public_path__ + "static/media/left_menu.0ac2df98.jpg";